const HomeEmail = () => {
  return (
    <section className="home_email_section">
      <div className="container">
        <div className="email_con">
          <h3 className="mail_heading">JOIN OUR NEWSLETTER</h3>
          <input
            type="text"
            name="subscribe_email"
            placeholder="Enter your Email"
          />
          <button className="button subscribe_btn">Subscribe</button>
        </div>
      </div>
    </section>
  );
};

export default HomeEmail;
